export enum MessageStatusType {
    DRAFT = 'DRAFT',
    QUEUED = 'QUEUED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    SENT = 'SENT',
}
